import { render, staticRenderFns } from "./parkingApproval.vue?vue&type=template&id=581b06ce&scoped=true&"
import script from "./parkingApproval.vue?vue&type=script&lang=js&"
export * from "./parkingApproval.vue?vue&type=script&lang=js&"
import style0 from "./parkingApproval.vue?vue&type=style&index=0&id=581b06ce&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581b06ce",
  null
  
)

export default component.exports